"use strict";
/*
 * Created on 1. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var moment = require("moment");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var RoundedProductPriceRequired_1 = require("../../product/model/RoundedProductPriceRequired");

var UserMessageCode_1 = require("../../user-messages/model/UserMessageCode");

var FinalPriceType_1 = require("./FinalPriceType");

var FinalProductPriceValidationKey_1 = require("./FinalProductPriceValidationKey");
/**
 * Final price of product.
 * @author Radek Beran
 */


var FinalProductPrice =
/*#__PURE__*/
function (_RoundedProductPriceR) {
  _inherits(FinalProductPrice, _RoundedProductPriceR);

  /**
   * @param priceZoneId identifier of price zone for which is the price valid
   * @param priceType type of selected final price, if null, user did not specified the price after automatic calculation
   * @param value value of the price
   * @param valueRounded value of the price rounded according to rounding rules
   * @param vatRate VAT rate in percent
   * @param lastExportedValue last exported value of the price
   * @param lastExportedValidFrom start of validity of the last exported final price
   * @param forecast forecast of sold amount from optimization engine (for 30 days, for all regular, EDLP and sellout releases)
   *        (with old or with new settings according to chosen final price type)
   * @param validFrom start of price validity
   * @param validTo end of price validity (null if valid to infinity). For sellouts, it should be always filled.
   * @param originalValidTo originally set validTo, filled if user manually changed validTo value to a different value
   * @param changedByUserId user id who manually changed price
   * @param changedByUserName user name who manually changed price
   * @param changeDate date when price has been manually changed
   * @param validationResult validation messages
   */
  function FinalProductPrice(priceZoneId, priceType, value, valueRounded, vatRate, lastExportedValue, //relevant only for sellout releases
  lastExportedValidFrom, //relevant only for sellout releases
  forecast, validFrom, validTo, originalValidTo, changedByUserId, changedByUserName, changeDate, validationResult) {
    var _this;

    _classCallCheck(this, FinalProductPrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FinalProductPrice).call(this, value, valueRounded));
    _this.priceZoneId = priceZoneId;
    _this.priceType = priceType;
    _this.value = value;
    _this.valueRounded = valueRounded;
    _this.vatRate = vatRate;
    _this.lastExportedValue = lastExportedValue;
    _this.lastExportedValidFrom = lastExportedValidFrom;
    _this.forecast = forecast;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.originalValidTo = originalValidTo;
    _this.changedByUserId = changedByUserId;
    _this.changedByUserName = changedByUserName;
    _this.changeDate = changeDate;
    _this.validationResult = validationResult;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to final price.
   */


  _createClass(FinalProductPrice, [{
    key: "withValidationResult",
    value: function withValidationResult(validationResult) {
      return this.copy('validationResult', validationResult);
    }
  }, {
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObject(message));
    }
    /**
     * Returns final price with given alerts added.
     * Given alerts are merged with the current ones.
     * @param validationResult
     */

  }, {
    key: "withFinalPriceAlerts",
    value: function withFinalPriceAlerts(validationResult) {
      // Remove old final price alerts
      // TODO RBe: Do not duplicate this in OptimalPrice (FinalPriceBelowPurchase is only in final price)
      var messagesToClean = immutable_1.Set.of(FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.FinalPriceBelowPurchase, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.SelloutFinalPriceBelowPurchase, UserMessageCode_1.UserMessageCode.PriceViolatesRefPriceDistance, UserMessageCode_1.UserMessageCode.PriceViolatesPriceChangeLimit, UserMessageCode_1.UserMessageCode.PriceViolatesPromoPriceDistance, UserMessageCode_1.UserMessageCode.MarginOutOfRange, UserMessageCode_1.UserMessageCode.PriceBreaksFamilySizePricing, UserMessageCode_1.UserMessageCode.PriceBreaksFamilyLinePricing, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.PriceValidityEndAfterExpirationDate, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.PriceValidityEndNotMetByForecast, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.DiscountTooLow, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.MultipleRepricings, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.FinalPriceLowerThanPreviousPromoPrice, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.FinalPriceViolatesMinPriceChange, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.FinalPriceViolatesMaxPriceChange, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.FinalPriceValueChangedDueToRecalculation);
      var currentCleaned = this.validationResult.removeObjectsWithMessageKeys(messagesToClean); // Add new alerts

      return this.copy('validationResult', currentCleaned.mergeWithResult(validationResult));
    }
  }, {
    key: "withPriceValue",
    value: function withPriceValue(value, valueRounded) {
      return this.copy('value', value).copy('valueRounded', valueRounded);
    }
  }, {
    key: "withChangedByUser",
    value: function withChangedByUser(user) {
      return this.copy('changedByUserId', user.id).copy('changedByUserName', user.name).copy('changeDate', moment());
    }
    /**
     * Returns value without VAT (LOG-5292).
     */

  }, {
    key: "getValueWithoutVAT",
    value: function getValueWithoutVAT() {
      return this.vatRate === null ? this.getPresentedValue() : this.getPresentedValue() !== null ? PriceFormulas_1.PriceFormulas.computeNetPrice(this.getPresentedValue(), this.vatRate) : null;
    }
    /**
     * @returns True if {@link .priceType} is of type {@link FinalPriceType.Manual manual}, false otherwise.
     */

  }, {
    key: "isOfTypeManual",
    value: function isOfTypeManual() {
      return this.priceType === FinalPriceType_1.FinalPriceType.Manual;
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new FinalProductPrice(mat.priceZoneId, mat.priceType, mat.value, mat.valueRounded, mat.vatRate, mat.lastExportedValue, mat.lastExportedValidFrom, mat.forecast, mat.validFrom, mat.validTo, mat.originalValidTo, mat.changedByUserId, mat.changedByUserName, mat.changeDate, mat.validationResult);
    }
    /**
     * Returns true if given value is valid for final price.
     * @param value
     */

  }, {
    key: "isValidValue",
    value: function isValidValue(value) {
      return !value.isNegative() && !value.isZero();
    }
  }]);

  return FinalProductPrice;
}(RoundedProductPriceRequired_1.RoundedProductPriceRequired);

exports.FinalProductPrice = FinalProductPrice;

FinalProductPrice.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(FinalProductPrice.name);
  return {
    priceZoneId: builder.str('priceZoneId'),
    priceType: builder.opt(builder.senum('priceType', FinalPriceType_1.FinalPriceType, CodebookLookupSequence_1.CodebookLookupSequence.FinalPriceType)),
    value: builder.bigNum('value'),
    valueRounded: builder.opt(builder.bigNum('valueRounded')),
    vatRate: builder.opt(builder.bigNum('vatRate')),
    lastExportedValue: builder.opt(builder.bigNum('lastExportedValue')),
    lastExportedValidFrom: builder.opt(builder.date('lastExportedValidFrom', DateParser_1.DateParser.ISO_PATTERN)),
    forecast: builder.opt(builder.bigNum('forecast')),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.opt(builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)),
    originalValidTo: builder.opt(builder.date('originalValidTo', DateParser_1.DateParser.ISO_PATTERN)),
    changedByUserId: builder.opt(builder.str('changedByUserId')),
    changedByUserName: builder.opt(builder.str('changedByUserName')),
    changeDate: builder.opt(builder.date('changeDate', DateParser_1.DateParser.ISO_PATTERN)),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();